var _circle, _path, _circle2, _circle3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#CBF4C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.572 8.14026H6.62333C6.24874 8.14026 5.88949 8.28906 5.62462 8.55394C5.35974 8.81881 5.21094 9.17806 5.21094 9.55265V20.8518C5.21094 21.2263 5.35974 21.5856 5.62462 21.8505C5.88949 22.1153 6.24874 22.2641 6.62333 22.2641H16.3404C16.5277 22.2641 16.7073 22.1897 16.8398 22.0573C16.9722 21.9249 17.0466 21.7452 17.0466 21.558C17.0466 21.3707 16.9722 21.191 16.8398 21.0586C16.7073 20.9262 16.5277 20.8518 16.3404 20.8518H9.4481C9.4481 20.1026 9.15049 19.3841 8.62074 18.8543C8.091 18.3246 7.3725 18.027 6.62333 18.027V12.3774C7.3725 12.3774 8.091 12.0798 8.62074 11.5501C9.15049 11.0203 9.4481 10.3018 9.4481 9.55265H20.7472C20.7472 10.3018 21.0448 11.0203 21.5746 11.5501C22.1043 12.0798 22.8228 12.3774 23.572 12.3774V14.9089C23.572 15.0961 23.6464 15.2758 23.7788 15.4082C23.9113 15.5406 24.0909 15.615 24.2782 15.615C24.4655 15.615 24.6451 15.5406 24.7775 15.4082C24.91 15.2758 24.9844 15.0961 24.9844 14.9089V9.55265C24.9844 9.17806 24.8356 8.81881 24.5707 8.55394C24.3058 8.28906 23.9466 8.14026 23.572 8.14026ZM8.03571 20.8518H6.62333V19.4394C6.99791 19.4394 7.35716 19.5882 7.62204 19.853C7.88691 20.1179 8.03571 20.4772 8.03571 20.8518ZM6.62333 10.965V9.55265H8.03571C8.03571 9.92724 7.88691 10.2865 7.62204 10.5514C7.35716 10.8162 6.99791 10.965 6.62333 10.965ZM22.1596 9.55265H23.572V10.965C23.1974 10.965 22.8382 10.8162 22.5733 10.5514C22.3084 10.2865 22.1596 9.92724 22.1596 9.55265Z",
    fill: "#3E556D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7503,
    cy: 15.3501,
    r: 2.39091,
    stroke: "#3E556D",
    strokeWidth: 1.1554
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1507,
    cy: 19.8826,
    r: 3.75616,
    fill: "#CBF4C9",
    stroke: "#3E556D",
    strokeWidth: 1.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.919,
    y1: 19.9735,
    x2: 21.6808,
    y2: 20.7354,
    stroke: "#3E556D",
    strokeWidth: 0.957091,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.6719,
    y1: 20.7386,
    x2: 23.375,
    y2: 19.0355,
    stroke: "#3E556D",
    strokeWidth: 0.957091,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCheckIcon);
export default __webpack_public_path__ + "static/media/PaymentCheckIcon.f7127217c8770703fe86a11dbf13f915.svg";
export { ForwardRef as ReactComponent };